module.exports = __webpack_public_path__ + "img/search_02.dc80cd20.png";